import { BasicConstants } from "../../basic/constants/BasicConstants";

/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 04.09.13, 10:46
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class ForumLinkComposer {
    public static URL_FORUM_STAGING: string = BasicConstants.DOMAIN_PROTOCOL + "://forum-loginserver-staging.goodgamestudios.com/vanilla";
    public static URL_FORUM_PRODUCTION: string = BasicConstants.DOMAIN_PROTOCOL + "://forum-loginserver.goodgamestudios.com/vanilla";
    public static URL_FORUM_PUBLIC: string = BasicConstants.DOMAIN_PROTOCOL + "://{language}.board.goodgamestudios.com/{title}";

    private static DEFAULT_PLACEHOLDER: RegExp = /\{.*?\}/;

    /**
     * Composes a valid forum URL with the form hash from server.
     *
     * General link structure:
     * [forum-url][hash]
     *
     * @param hash Forum server hash
     * @param isTest Indicates if the client runs in test environment
     *
     * @return Composed forum URL
     */
    public static composeForumURL(hash: string, isTest: boolean): string {
        let pathElements: any[] = [];

        if (isTest) {
            pathElements.push(ForumLinkComposer.URL_FORUM_STAGING);
        }
        else {
            pathElements.push(ForumLinkComposer.URL_FORUM_PRODUCTION);
        }

        // HASH
        if (hash != "") {
            pathElements.push(hash);
        }

        return pathElements.join("/");
    }

    public static composeForumURLWithoutAuth(language: string, gameTitle: string): string {
        return ForumLinkComposer.URL_FORUM_PUBLIC.replace(ForumLinkComposer.DEFAULT_PLACEHOLDER, language).replace(ForumLinkComposer.DEFAULT_PLACEHOLDER, gameTitle);
    }
}
